import React from 'react';
import {
    FoodLabelLeft as FoodLabel,
    FoodContainer,
    ImageDetails,
    Description,
    Price,
    FoodImage,
} from '../FoodGrid';
import { Title } from '../Styles/title';
import FoodOOS from './FoodOOS';
import FoodHidden from './FoodHidden';
import { Typography } from '@mui/material';

function ImageLeft(props) {
    const {
        sectionId,
        foodId,
        price,
        desc,
        oos,
        name,
        imgSrc,
        hide,
        defaultImgSrc,
        onFoodClick,
        serves,
        uom,
    } = props;
    return (
        <FoodContainer key={sectionId + foodId} oos={oos} onClick={onFoodClick}>
            <FoodLabel>
                {imgSrc ? (
                    <FoodImage src={imgSrc} alt={name} />
                ) : (
                    <FoodImage src={defaultImgSrc} alt={name} />
                )}
                <ImageDetails>
                    <Title>
                        <span opacity="0.5">
                            <b>{name} </b>
                        </span>
                        {oos ? <FoodOOS /> : null}
                        {hide && hide === true ? <FoodHidden /> : null}
                    </Title>
                    {uom !== 'people' && serves && (
                        <Typography
                            sx={{
                                mt: 1,
                            }}
                            variant="body2"
                        >
                            {serves.min === serves.max
                                ? serves.min > 1
                                    ? `Serves ${serves.min}`
                                    : ''
                                : `Serves ${serves.min} - ${serves.max}`}
                        </Typography>
                    )}
                    <Description>{desc}</Description>
                    <Price>{price}</Price>
                </ImageDetails>
            </FoodLabel>
        </FoodContainer>
        // <PopularItem
        //     data={{
        //         name: name,
        //         desc: desc,
        //         price: price,
        //         img: imgSrc,
        //         oos: oos,
        //         hide: hide,
        //     }}
        // />
    );
}

ImageLeft.propTypes = {};

export default ImageLeft;
